import { IonContent, IonImg, IonLabel, IonPage } from "@ionic/react";
import { ChangeEvent, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { RouteComponentProps } from "react-router";
import imageMenuDock from "../../assets/image/logo.png";
import mobile from "../../assets/image/mobile.png";
import { Button } from "../../components/button/button";
import { Footer } from "../../components/footer/footer";
import Header from "../../components/header/header";
import FormField from "../../components/inputs/input";
import { ReturnRequest } from "../../components/returnLoginComponent/returncomponentLogin";
import { OrganizationSelector } from "../../components/selector/selectos/organizationSelector";
import { AppRoutes } from "../../constants/appRoutes";
import { DefaultValues } from "../../constants/defaultValues";
import { MaxLengths } from "../../constants/maxLengths";
import { getUserClaimsAction, registerUserNotificationAction } from "../../redux/actions/user/user";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { updateuserSignupProperty } from "../../redux/reducers/signup/form";
import { compileNameOfProperty } from "../../utils/utils";
import { isValidPhoneNumber } from "../../validation/validation";
import { AboutBrowserController } from "../aboutBrowser/controller";
import { AboutSecurityController } from "../aboutSecurity/controller";
import { LoginContainerStyle } from "./containerStyle.jss";
import { LoginResolver } from "./resolver";
export interface IUserSignup {
    phoneNumber: string;
    organizationId: string;
}

const LoginContainer: React.FC<RouteComponentProps> = ({ history }) => {
    const { t } = useTranslation("common");
    const theme = useTheme();
    const style = LoginContainerStyle({ theme });
    const dispatch = useAppDispatch();

    const { form } = useAppSelector((state) => state.userSignupForm);

    const {
        formState: { errors },
        control,
    } = useForm<IUserSignup>({ mode: "onChange", resolver: LoginResolver });

    const isValidForm = useMemo(() => isValidPhoneNumber(form.phoneNumber) && form.organizationId !== "", [form]);

    const onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value;
        let name = compileNameOfProperty<IUserSignup>("phoneNumber");
        dispatch(updateuserSignupProperty({ name, value }));
    };

    const userSingIn = () => {
        dispatch(getUserClaimsAction()).then((response: any) => {
            if (response) {
                dispatch(registerUserNotificationAction());
                return history.push(AppRoutes.REQUEST);
            }
        });
    };

    const onChangeSelector = (ev: CustomEvent) => {
        dispatch(updateuserSignupProperty({ name: compileNameOfProperty<IUserSignup>("organizationId"), value: ev.detail.value }));
    };

    return (
        <IonPage>
            <Header
                element={
                    <span className={style.imageContent}>
                        <IonImg
                            className={style.image}
                            src={imageMenuDock}
                        />
                    </span>
                }
                title={DefaultValues.DEFAULT_TEXT}
                showLogout={false}
            />

            <IonContent>
                <div className={style.container}>
                    <div className={style.section}>
                        <div className={style.message}>
                            <IonLabel className="ion-text-center">{t("GLOBAL.WELCOME")}</IonLabel>
                            <IonLabel className="ion-text-center">{t("MESSAGES.LOGIN_MESSAGE")}</IonLabel>
                        </div>

                        <div className={style.form}>
                            <div className={style.row}>
                                <OrganizationSelector
                                    onChange={onChangeSelector}
                                    selectedKey={form.organizationId}
                                    control={control}
                                    name={compileNameOfProperty<IUserSignup>("organizationId")}
                                    rules={{
                                        required: true,
                                    }}
                                />
                            </div>

                            <div className={style.row}>
                                <img
                                    src={mobile}
                                    className={style.icon}
                                />
                                <FormField
                                    value={form.phoneNumber}
                                    label={t("PAGE.LOGIN.PHONE")}
                                    onChange={onChangeInput}
                                    control={control}
                                    type={"text"}
                                    name={compileNameOfProperty<IUserSignup>("phoneNumber")}
                                    error={errors.phoneNumber}
                                    maxLength={MaxLengths.PHONE_NUMBER}
                                />
                            </div>
                            <div className={`${style.row} ${style.signUpBtn}`}>
                                <Button
                                    color="secondary"
                                    title={t("GLOBAL.LOGIN")}
                                    disabled={!isValidForm}
                                    onClick={userSingIn}
                                />
                            </div>
                        </div>
                    </div>

                    <AboutSecurityController />
                </div>
            </IonContent>
            <Footer
                element={<AboutBrowserController />}
                hideBorder={true}
            />
            <ReturnRequest />
        </IonPage>
    );
};

export default LoginContainer;
